<!doctype html>

<html lang="hu">

<body id="body">
    <div style="height:100%;width:100%" ui-view></div>
</body>

</html>